(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('billing-frequency', {
            parent: 'entity',
            url: '/billing-frequency',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Billing Frequencies'
            },
            ncyBreadcrumb: {
                label: 'Billing Frequencies',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/billing-frequency/billing-frequencies.html',
                    controller: 'BillingFrequencyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('billing-frequency-detail', {
            parent: 'entity',
            url: '/billing-frequency/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'BillingFrequency'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-detail.html',
                    controller: 'BillingFrequencyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'BillingFrequency', function($stateParams, BillingFrequency) {
                    return BillingFrequency.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'billing-frequency',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('billing-frequency-detail.edit', {
            parent: 'billing-frequency-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-dialog.html',
                    controller: 'BillingFrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BillingFrequency', function(BillingFrequency) {
                            return BillingFrequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('billing-frequency.new', {
            parent: 'billing-frequency',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-dialog.html',
                    controller: 'BillingFrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                days: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('billing-frequency', null, { reload: 'billing-frequency' });
                }, function() {
                    $state.go('billing-frequency');
                });
            }]
        })
        .state('billing-frequency.edit', {
            parent: 'billing-frequency',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-dialog.html',
                    controller: 'BillingFrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BillingFrequency', function(BillingFrequency) {
                            return BillingFrequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('billing-frequency', null, { reload: 'billing-frequency' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('billing-frequency.delete', {
            parent: 'billing-frequency',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-delete-dialog.html',
                    controller: 'BillingFrequencyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BillingFrequency', function(BillingFrequency) {
                            return BillingFrequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('billing-frequency', null, { reload: 'billing-frequency' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
